<!--微信端订阅首页-->
<template>
  <div class="page">
    <div class="container" v-loading="loading">
      <div class="title">
        <h1>
          <span class="_type">{{ data.style }}</span>{{ data.title }}
        </h1>
      </div>
      <div class="info">
        <div>
          <span class="label">发文机关</span>{{ data.organ || "暂无数据" }}
        </div>
        <div>
          <span class="label">发文字号</span>{{ data.issued_number || "暂无数据" }}
        </div>
        <div>
          <span class="label">发布时间</span>{{ data.publish_time || "暂无数据" }}
        </div>
        <div>
          <span class="label">政策类型</span>{{ data.style || "暂无数据" }}
        </div>
        <div class="targ" v-if="data.theme">
          <span v-for="tag, index in data.theme?.split(';')" :key="index">{{ tag }}</span>
        </div>
      </div>
      <div class="content" :class="{ 'show-all': showAll }">
        <template v-for="(item2, index4) in this.dataHtmlFullText">
          <template v-for="(item, index) in item2">
            <template v-if="item.htmlTag == 'P'">
              <p :key="index + index4 + 'P'">
                <template v-for="(
                                itemContent, indexContent
                              ) in item.listHtmlContent">
                  <template v-if="itemContent.contentType == '1'">{{
                    itemContent.contentMain
                  }}</template>
                  <template v-else-if="itemContent.contentType == '2'">
                    <el-popover placement="top" width="360" :key="indexContent" @show="changeRelation(itemContent.zlfId)">
                      <!-- <div v-html="content"></div> -->
                      <div class="box-content">
                        <div class="news-list">
                          <ul>
                            <li v-for="(
                                            item, index1
                                          ) in zlfRelationList" :key="index1">
                              <a target="_blank" :href="'http://qikan.cqvip.com/Qikan/Article/Detail?id=' +
                                item._id
                                ">{{ item.title_c }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <span slot="reference">{{
                        itemContent.contentMain
                      }}</span>
                    </el-popover>
                  </template>
                </template>
              </p>
            </template>
            <template v-if="item.htmlTag == 'SUBTITLE'">
              <P class="p_c" :key="index + index4 + 'SUBTITLE'">
                <strong>{{ item.listHtmlContent[0].contentMain }}</strong>
              </P>
            </template>
            <template v-if="item.htmlTag == 'MAINSENDINGMECHANISM'">
              <P :key="index + index4" class="no-indent">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'ISSUEDNUMBER'">
              <P class="p_c" :key="index + index4 + 'ISSUEDNUMBER'">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'ISSUINGAUTHORITY'">
              <P :key="index + index4" class="issuing">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'ISSUINGTIME'">
              <P :key="index + index4" class="issuing">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'H1'">
              <H1 :key="index + index4 + 'H1'">
                {{ item.listHtmlContent[0].contentMain }}
              </H1>
            </template>
            <template v-if="item.htmlTag == 'H2'">
              <H2 :key="index + index4 + 'H2'">
                {{ item.listHtmlContent[0].contentMain }}
              </H2>
            </template>
            <template v-if="item.htmlTag == 'H3'">
              <H3 :key="index + index4 + 'H3'">
                {{ item.listHtmlContent[0].contentMain }}
              </H3>
            </template>
            <template v-if="item.htmlTag == 'H4'">
              <H4 :key="index + index4 + 'H4'">
                {{ item.listHtmlContent[0].contentMain }}
              </H4>
            </template>
            <template v-if="item.htmlTag == 'IMAGEINFO'">
              <div class="image_title" :key="index + index4 + 'IMAGEINFO'">
                {{ item.listHtmlContent[0].contentMain }}
              </div>
            </template>
            <template v-if="item.htmlTag == 'IMAGEURL'">
              <div class="image" :key="index + index4 + 'IMAGEURL'">
                <img :src="item.listHtmlContent[0].contentMain" />
              </div>
            </template>
            <template v-if="item.htmlTag == 'APPENDIX'">
              <template v-for="(item3, index3) in item2">
                <template v-if="item3.htmlTag == 'FILEURL'">
                  <template v-if="item3.listHtmlContent[0].contentMain == ''
                    ">
                    <!-- <P :key="index3 + index + index4">
                                    {{ item.listHtmlContent[0].contentMain }}
                                  </P> -->
                  </template>
                  <template v-else>
                    <P class="appendix" :key="index3 + index + index4">
                      <a target="myIframe" rel="noopener"
                        v-log="{ kind: 2, detailId: $route.params.id, attachmentName: item.listHtmlContent[0].contentMain }"
                        :key="index3 + index + index4" :href="item3.listHtmlContent[0].contentMain">
                        {{ item.listHtmlContent[0].contentMain }}
                      </a>
                    </P>
                  </template>
                </template>
                <template v-if="item3.htmlTag == 'FILEDATA'">
                  <P class="appendix" :key="index3 + index + index4">
                    <a href="javascript:void(0)" @click="
                      downData(
                        item3.listHtmlContent[0].contentMain,
                        item.listHtmlContent[0].contentMain
                      )
                      ">{{ item.listHtmlContent[0].contentMain }}</a>
                  </P>
                </template>
              </template>
            </template>
            <template v-if="item.htmlTag == 'TABLEINFO'">
              <div class="table_title" :key="index + index4 + 'TABLEINFO'">
                {{ item.listHtmlContent[0].contentMain }}
              </div>
            </template>
            <template v-if="item.htmlTag == 'TABLE'">
              <div class="table" :key="index + index4">
                <table>
                  <tr v-for="(item2, index6) in JSON.parse(item.listHtmlContent[0].contentMain)" :key="index6">
                    <td v-for="(item3, index7) in item2" :key="index7">
                      {{ item3.td }}
                    </td>
                  </tr>
                </table>
              </div>
            </template>
            <template v-if="item.htmlTag == 'P_L'">
              <P :key="index + index4 + 'P_L'" class="p_l">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'P_R'">
              <P :key="index + index4 + 'P_R'" class="p_r">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'P_C'">
              <P :key="index + index4 + 'P_C'" class="p_c">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
            <template v-if="item.htmlTag == 'P_S'">
              <P :key="index + index4 + 'P_S'" class="p_s">
                {{ item.listHtmlContent[0].contentMain }}
              </P>
            </template>
          </template>
        </template>
        <div v-show="!showAll" class="op" @click="clickShowAll">
          <el-button type="primary">展开全部内容</el-button>
        </div>
      </div>
      <div v-show="related.relatedShow">
        <div class="inner-title">上级政策</div>
        <div class="policy-list">
          <div class="list-item" v-for="item in related.relatedList" :key="item.lngid">
            <router-link :to="`/mobile/policy/${item.lngid}`">{{ item.title }}</router-link>
          </div>
        </div>
      </div>
      <div v-show="related.downrelatedShow">
        <div class="inner-title">下级政策</div>
        <div class="policy-list">
          <div class="list-item" v-for="item in related.downrelatedList" :key="item.lngid">
            <router-link :to="`/mobile/policy/${item.lngid}`">{{ item.title }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="page-tools">
      <div class="tool-item" @click="showNotes">
        <i class="icon iconfont icon-zhishi"></i>
        笔记
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="notesVisible" width="30%">
      <div class="notes-list" v-loading="notesDataLoading">
        <div class="notes-item" v-for="item in notesData" :key="item.id">
          <div class="_name">
            <el-avatar :src="headImage" :size="40"></el-avatar>
            <span>{{ item.userName }}</span>
          </div>
          <div class="_text">
            <label>正文：</label>{{ item.taggingContent }}
          </div>
          <div class="_note">
            <label>批注：</label>{{ item.remark }}
          </div>
        </div>
        <el-empty v-if="notesData?.length === 0" description="抱歉，暂无笔记数据。" />
      </div>
      <template slot="footer">
        <el-button type="primary" @click="notesVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDetail,
  notetaggingpages,
  addexcerpts,
  modexcerpts,
  delexcerpts,
  searchListByRule,
  getQuote,
  getcitedbydata,
  analysisgraph,
  getsimilarbydata,
  addOrUpdateArticleNote,
} from "@/utils/knowlegebase";
import { checkIfMobile } from '@/utils/mobile'
export default {
  name: "MIndex",
  components: {
  },
  data () {
    return {
      hasSearch: false,
      data: [],
      dataHtmlFullText: [],
      loading: false,
      showAll: false,
      related: {
        relatedList: [],
        relatedLoading: false,
        relatedShow: true,
        pageNum: 1,
        pageSize: 99,
        totalCount: 0,
        downrelatedList: [],
        downrelatedLoading: false,
        downrelatedShow: true,
        downpageNum: 1,
        downpageSize: 99,
        downtotalCount: 0,
      },
      notesVisible: false,
      notesDataLoading: false,
      notesData: [],
      headImage: require("@/assets/images/avatar-default.png"),
    };
  },
  computed: {
    notesDataParmars () {
      return {
        PageIndex: 1,
        PageSize: 100,
        articleId: this.$route.params.id,
        king: 1,
        onlyMy: false,
      }
    }
  },
  mounted () {
    if (Object.keys(this.$route.params).length > 0 && this.$route.params.id) {
      if (!checkIfMobile()) {
        this.$router.push(`/Policy/${this.$route.params.id}`)
      }
      this.getData()
    }
  },
  methods: {
    getData () {
      this.loading = true;
      getDetail({ id: this.$route.params.id })
        .then((res) => {
          this.data = res.data.data.detail;
          if (this.data.themeList.length > 0) {
            this.isThemeListShow = true;
          }
          this.dataHtmlFullText = this.data.listHtmlFullText;

          let json = JSON.parse(this.data.fulltext);
          for (var key in json) {
            for (var key1 in json[key]) {
              this.fulltext =
                this.fulltext +
                "<" +
                key1 +
                ">" +
                json[key][key1] +
                "</" +
                key1 +
                ">";
            }
          }
          this.handleSearchRelared();
          this.handleSearchdownRelared();
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        });
    },
    /**关联政策  根据关键词匹配*/
    handleSearchRelared () {
      console.log('related')
      this.related.relatedLoading = true;
      this.related.downrelatedLoading = true;
      getQuote({
        articleId: this.data._id,
        pageNum: this.related.pageNum,
        pageSize: this.related.pageSize,
      }).then((res) => {

        if (res.data.apiStatusCode == 1000) {
          this.related.relatedList = res.data.data.list ?? [];
          this.related.totalCount = res.data.data.totalCount;
          if (this.related.relatedList.length === 0) {
            this.related.relatedShow = false
          }
        } else {
          this.$message({ message: `获取失败-` + res.data.message, type: "error" });
        }
        this.related.relatedLoading = false;
      });
    },
    //关联下级政策
    handleSearchdownRelared () {
      getcitedbydata({
        articleId: this.data._id,
        pageNum: this.related.downpageNum,
        pageSize: this.related.downpageSize,
      }).then((res) => {
        if (res.data.apiStatusCode == 1000) {

          this.related.downrelatedList = res.data.data.list ?? [];
          this.related.downtotalCount = res.data.data.totalCount;
          if (this.related.downrelatedList.length === 0) {
            this.related.downrelatedShow = false
          }
        } else {
          this.$message({ message: `获取失败-` + res.data.message, type: "error" });
        }
        this.related.downrelatedLoading = false;
      });
    },
    //展开全部内容
    clickShowAll () {
      this.showAll = true;
    },
    //获取笔记
    getNotesData () {
      this.notesDataloading = true;
      notetaggingpages(this.notesDataParmars).then((res) => {
        if (res.data.apiStatusCode == 1000) {
          this.notesData = res.data.data.pagelist.items;

        } else {
          this.$message({ message: `获取失败-` + res.data.message, type: "error" });
        }
        this.notesDataloading = false;
      });
    },
    //显示笔记 
    showNotes () {
      this.notesVisible = true
      this.getNotesData()
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";

.container {
  padding: 0 !important;
  border-radius: 5rem 5rem 0 0 !important;
  background-color: #fff;
  gap: 0 !important;

  >div {
    padding: 15rem 20rem;
    border-radius: 0 !important;
    box-shadow: none !important;
    border-top: 10rem solid #f6f6f6;

    &:first-child {
      border-top: 0;
    }
  }

  .inner-title {
    margin-bottom: 4rem;
    font-size: 16rem;
    font-family: "SourceHanSerifCN-Bold";
  }
}

.title {
  font-family: "SourceHanSerifCN-Bold";
  text-align: justify;

  ._type {
    display: inline-block;
    margin-inline: -6rem;
    font-size: 15rem;
    color: #dc0600;

    &:before {
      content: "【";
    }

    &:after {
      content: "】";
    }
  }

  h1 {
    font-size: 18rem;
    line-height: 28rem;
    color: #000;
  }
}

.info {
  margin-top: -20rem;
  border-top: 0 !important;

  >div {
    font-size: 12rem;
    line-height: 20rem;
    color: #a3a3a3;

    .label {
      &:after {
        content: "：";
      }
    }
  }

  .targ {
    margin-top: 4rem;

    span {
      display: inline-flex;
      line-height: 16rem;
      max-width: 80rem;
      min-width: 40rem;
      height: 16rem;
      margin-right: 10rem;
      padding: 0 8rem;
      font-size: 10rem;
      color: $colorMain;
      background-color: #ffe6dc;
      border-radius: 999px;
      @include clip;
    }
  }
}

.content {
  overflow: hidden;
  position: relative;
  font-size: 14rem;
  line-height: 24rem;
  text-align: justify;
  min-height: 300rem;

  &.show-all {
    overflow: visible;
    min-height: inherit;
  }

  .op {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70rem;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);

    .el-button {
      width: 100rem;
      height: 25rem;
      padding: 0 !important;
      font-size: 12rem;
      line-height: 25rem;
      border-radius: 5rem;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    margin-bottom: 12rem !important;
    font-size: 14rem;
    line-height: 2 !important;
    font-family: "SourceHanSerifCN-Bold";
  }

  h1 {
    font-size: 16rem;

    +h2 {
      margin-top: -8rem;
    }
  }

  h2 {
    font-size: 15rem;

    +h3 {
      margin-top: -8rem;
    }
  }

  h3 {
    font-size: 14rem;

    +h4 {
      margin-top: -8rem;
    }
  }

  h4 {
    font-size: 14rem;
  }

  p {
    margin-bottom: 12rem !important;
    font-size: 14rem !important;
    line-height: 2 !important;
    text-indent: 2em;
    font-family: "SourceHanSerifCN-Medium", "Microsoft YaHei", "SimSun" !important;

    &.no-indent {
      text-indent: 0em;
    }

    &.align-right {
      text-indent: 0em;
      text-align: right;
    }
  }

  a {
    color: #4781ff;
    text-decoration: underline;

    &:hover {
      opacity: 0.6;
    }
  }

  table {
    border-collapse: collapse;
  }

  td,
  th {
    padding: 5rem 10rem;
    line-height: 1.5;
    border: 1px solid #ebeef5;
  }

  .image {
    margin-bottom: 12rem !important;
    text-align: center;

    &_title {
      font-size: 12rem;
      text-align: center;
      line-height: 2;
    }

    img {
      max-width: 100%;
    }
  }

  .table {
    margin-bottom: 12rem !important;
    text-align: center;

    &_title {
      font-size: 12rem;
      text-align: center;
      line-height: 2;
    }

    table {
      max-width: 100%;
    }
  }

  .issuing {
    text-align: right;
    text-indent: 0 !important;

    +.issuing {
      margin-top: -1em;
    }
  }

  .p_l {
    text-align: left;
    text-indent: 0 !important;
  }

  .p_r {
    text-align: right;
    text-indent: 0 !important;
  }

  .p_c {
    text-align: center;
    text-indent: 0 !important;
  }

  .appendix {
    font-size: 12rem !important;
    text-align: left;
    text-indent: 0 !important;
  }
}

.policy-list {
  .list-item {
    padding: 4rem 0;
    font-size: 12rem;
    line-height: 20rem;
    text-align: justify;

    a {
      color: #666666;
    }
  }
}



.notes-list {
  display: flex;
  flex-direction: column;
  gap: 8rem;
  margin: -10rem -20rem;
  background-color: #f5f5f5;

  .notes-item {
    width: 100%;
    padding: 16rem;
    background-color: #fff;

    ._name {
      display: flex;
      align-items: center;
      height: 50rem;
      margin-bottom: 4rem;
      color: #777777;
      font-size: 15rem;

      .el-avatar {
        width: 40rem !important;
        height: 40rem !important;
        margin-right: 12rem;
        box-shadow: 0 2rem 8rem rgba(255, 214, 200, .75);
      }

      >span:not(.el-avatar) {
        flex: 1;
        @include clips(1)
      }
    }

    ._text {
      font-size: 15rem;
      line-height: 25rem;
      @include clips(5)
    }

    ._note {
      font-size: 15rem;
      line-height: 25rem;
    }
  }
}
</style>